import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteWorkspacePlan } from "api/services/workspace-plan-service";
import { IWorkspacePlanModel } from "api/models/response/workspacePlan/IWorkspacePlanModel";
import { useAuthContext } from "hooks/useAuthContext";
import { WORKSPACE_PLANS_QUERY_KEY } from "hooks/workspacePlan/queryKeys";

export const useDeleteWorkspacePlan = () => {
    const queryClient = useQueryClient();
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const mutation = useMutation({
        mutationFn: (planId: string): Promise<void> =>
            deleteWorkspacePlan({ workspaceId, planId }),
        onSuccess: (_, planId) => {
            queryClient.setQueryData<IWorkspacePlanModel[]>(WORKSPACE_PLANS_QUERY_KEY, (prev) =>
                prev?.filter((plan) => plan.id !== planId)
            );
            queryClient.invalidateQueries({ queryKey: WORKSPACE_PLANS_QUERY_KEY });
        },
    });

    return {
        deletePlan: mutation.mutateAsync,
        deletingPlan: mutation.isPending,
    };
};
